export default __webpack_public_path__ + "static/media/paper26.7b5d5933.JPG";